import { useState } from 'react';
import PropTypes from 'prop-types';
import { getStudentInfo } from 'legacy-src/queries';
import useGetActions from './useGetActions';
import { isImpersonating } from 'legacy-src/components/impersonating/utils';

const useFetchStudent = (props) => {
  const { client, subject, dispatch } = props;
  const [state, setState] = useState(null);
  const _isImpersonating = isImpersonating();

  const actions = useGetActions({
    dispatch,
  });

  const loadStudentInfo = ({
    educationPeriodCode,
    userData,
    router,
    params,
  }) => {
    client
      .query({
        query: getStudentInfo,
        fetchPolicy: _isImpersonating ? 'network-only' : 'cache-first',
        variables: {
          id: subject,
          educationPeriod: educationPeriodCode,
        },
      })
      .then((response) => {
        setState(response);
        actions.setSubjectAction(userData, router, params);
      });
  };

  return [state, loadStudentInfo];
};

useFetchStudent.propTypes = {
  client: PropTypes.object.isRequired,
  subject: PropTypes.string.isRequired,
  educationPeriodCode: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default useFetchStudent;
